import { LatLngId, TargomoClient } from '@targomo/core';
import { PolygonGeoJsonOptions } from '@targomo/core/typings/api/payload';
import { FeatureCollection, MultiPolygon } from '@turf/helpers';

const targomoClient = new TargomoClient('westcentraleurope', process.env.VUE_APP_TARGOMO);

const GetPolygons = (sources: LatLngId[], options: PolygonGeoJsonOptions): Promise<FeatureCollection<MultiPolygon>> => {
  return targomoClient.polygons.fetch(sources, options);
};
const client = new TargomoClient('westcentraleurope', process.env.VUE_APP_TARGOMO);

const statsConfig = (time: number, travelType: 'walk' | 'car' | 'bike' | 'transit') => {
  const stats: {
    maxEdgeWeight: number;
    travelType: 'walk' | 'car' | 'bike' | 'transit';
    statisticsGroup: number;
    statistics: { id: number; name: string }[];
  } = {
    maxEdgeWeight: time,
    travelType: travelType,
    statisticsGroup: 123,
    statistics: [{ id: 0, name: 'test' }]
  };
  return stats;
};

const stats = (time: number, travelType: 'walk' | 'car' | 'bike' | 'transit') => {
  const stats: {
    statisticsGroup: number;
    statistics: { id: number; name: string; label: string; colors: Array<any> }[];
    maxEdgeWeight: number;
    colors: Array<any>;
    travelType: 'walk' | 'car' | 'bike' | 'transit';
  } = {
    statisticsGroup: 123,
    statistics: [
      {
        id: 29,
        name: 'Diploma',
        label: 'Diploma',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 30,
        name: 'Bepc',
        label: 'Bepc',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 31,
        name: 'Cap/Bep',
        label: 'Cap/Bep',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 32,
        name: 'Bac',
        label: 'Bac',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 33,
        name: 'Bac +2',
        label: 'Bac +2',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 34,
        name: 'Bac +3/4',
        label: 'Bac +3/4',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 35,
        name: 'Bac +5',
        label: 'Bac +5',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      }
    ],
    maxEdgeWeight: time,
    colors: ['#d73027', '#fc8d59', '#fee08b', '#d9ef8b', '#91cf60', '#1a9850'].reverse(),
    travelType: travelType
  };
  return stats;
};

const getData = async (coord: any[], time: number, travelType: 'walk' | 'car' | 'bike' | 'transit') => {
  const sources = [Object.assign({}, { lng: coord[0], lat: coord[1], id: 'Marker1' })];
  return await Promise.all([
    client.statistics.dependent(sources, stats(time, travelType)),
    client.statistics.travelTimes(sources, statsConfig(time, travelType))
  ]);
};

const getDataMap = async () => {
  const populationMeta = await client.statistics.metadataKey(123, { id: 0, name: 'test' });
  const tileRoute = await client.statistics.tileRoute(123, [{ id: 0, name: 'test' }]);
  return { populationMeta, tileRoute };
};

export default {
  GetPolygons,
  getData,
  getDataMap
};
